<template>
    <div>
        <a
            data-user-modal-link-social-authenticate-google
            @click.stop.prevent="startSocialFlow('google')"
            class="btn-google btn-block p-2 d-flex align-items-center justify-content-center border rounded fg-normal fg-normal-hover btn-lg"
            href="#"
            :title="googleTitle"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15px"
                height="15px"
                viewBox="0 0 48 48"
                class="google-svg no-margin"
            >
                <g>
                    <path
                        fill="#EA4335"
                        d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
                    ></path>
                    <path
                        fill="#4285F4"
                        d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
                    ></path>
                    <path
                        fill="#FBBC05"
                        d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
                    ></path>
                    <path
                        fill="#34A853"
                        d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
                    ></path>
                    <path fill="none" d="M0 0h48v48H0z"></path>
                </g>
            </svg>
            <span class="ml-1">{{ googleText }}</span>
        </a>

        <a
            v-if="type !== 'register' && type === 'login' && !isOc"
            data-user-modal-link-social-authenticate-facebook
            @click.stop.prevent="startSocialFlow('facebook')"
            class="btn-facebook btn-block mt-3 p-2 d-flex align-items-center justify-content-center border fg-white fg-white-hover btn-lg"
            href="#"
            :title="facebookTitle"
        >
            <i class="fab fa-facebook font-size-125 lh-inherit"></i>
            <span class="ml-1 lh-1">{{ facebookText }}</span>
        </a>
    </div>
</template>

<script>
import { globalLogger } from '../../../../../qaamgo/helper/global-logger';
import { satGlobals } from '../../../../../qaamgo/sat/helper/sat-globals';
import { testIsNonEmptyString } from '../../../../../lib/test-and-assert/test-base';
import { userManager } from '../../../user-manager';
import { pageNotification } from '../../../../../qaamgo/helper/notify';
import { getLocationHashWithoutModalPageFragment } from '../modal-fragment-helper';
import { projectHelper } from '../../../../misc/project-helper';

export default {
    name: 'SocialAuthenticationButtons',
    props: {
        type: {
            type: String,
            required: true,
            validator: function (value) {
                const validTypes = ['login', 'register'];

                return validTypes.includes(value);
            },
        },
        googleTitle: {
            type: String,
            required: true,
        },
        googleText: {
            type: String,
            required: true,
        },
        facebookTitle: {
            type: String,
            required: true,
        },
        facebookText: {
            type: String,
            required: true,
        },
        reloadPage: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        isOc() {
            return projectHelper.isOnlineConvert();
        },
    },
    methods: {
        startSocialFlow(provider) {
            // user modal - login attempt - social - start - google
            // user modal - login attempt - social - start - facebook
            // user modal - register attempt - social - start - google
            // user modal - register attempt - social - start - facebook
            globalLogger.log(`user modal - ${this.type} attempt - social - start - ${provider}`);

            const authenticateWindow = satGlobals.getApiUrl('/connect/' + provider + '/authenticate');

            const socialAuthenticationWindow = window.open(authenticateWindow, '_blank');

            this.waitForClosedTab(socialAuthenticationWindow, provider);
        },
        waitForClosedTab(socialAuthenticationWindow, provider) {
            if (!testIsNonEmptyString(provider)) {
                provider = 'unknown';
            }

            if (socialAuthenticationWindow.closed) {
                this.refreshUser(provider);
            } else {
                setTimeout(() => {
                    this.waitForClosedTab(socialAuthenticationWindow, provider);
                }, 500);
            }
        },
        async refreshUser(provider) {
            if (!testIsNonEmptyString(provider)) {
                provider = 'unknown';
            }

            try {
                const user = await userManager.getFreshUser();

                if (user.isAnonymous()) {
                    // user modal - login attempt - social - fail - google
                    // user modal - login attempt - social - fail - facebook
                    // user modal - register attempt - social - fail - google
                    // user modal - register attempt - social - fail - facebook
                    globalLogger.log(
                        `user modal - ${this.type} attempt - social - fail - ${provider}`,
                        'user not authenticated'
                    );

                    this.$emit('auth-fail');

                    return;
                }

                // user modal - login attempt - social - success - google
                // user modal - login attempt - social - success - facebook
                // user modal - register attempt - social - success - google
                // user modal - register attempt - social - success - facebook
                globalLogger.log(`user modal - ${this.type} attempt - social - success - ${provider}`);

                if (this.reloadPage) {
                    window.allowLeave = true;

                    let redirectLink = user.getExtraKey('redirect_after_login');

                    if (testIsNonEmptyString(redirectLink)) {
                        window.location = redirectLink;

                        return;
                    }

                    window.location.hash = getLocationHashWithoutModalPageFragment();

                    window.location.reload();

                    return;
                }

                this.$emit('auth-success');
            } catch (error) {
                // user modal - login attempt - social - fail - google
                // user modal - login attempt - social - fail - facebook
                // user modal - register attempt - social - fail - google
                // user modal - register attempt - social - fail - facebook
                globalLogger.log(`user modal - ${this.type} attempt - social - fail - ${provider}`, error);

                pageNotification.showGenericErrorMessage();
            }
        },
    },
};
</script>
